// extracted by mini-css-extract-plugin
module.exports = {"root":"Finitura_root__LkbIV"};